declare global {
  interface Window {
    Swiper: any;
  }
}

export function initEkReviewSlides(root: ParentNode = document): void {
  const sliders = root.querySelectorAll<HTMLElement>('.ek-review-slides');
  if (!sliders.length) return;

  if (typeof window.Swiper !== 'function') {
    setTimeout(() => initEkReviewSlides(root), 50);
    return;
  }

  const updateSlideSizes = (swiper: any, slider: HTMLElement) => {
    const isMobile = window.innerWidth < 768;
    const slides = slider.querySelectorAll<HTMLElement>('.ek-review-slide');
    const slideContents = slider.querySelectorAll<HTMLElement>('.ek-review-slide-content');
    
    if (isMobile) {
      slides.forEach((slide) => {
        slide.classList.remove('swiper-slide-active');
      });
      slideContents.forEach((content) => {
        content.classList.remove('md:scale-[0.8]', 'md:opacity-70', 'md:scale-100', 'md:opacity-100');
      });
      return;
    }

    const activeIndex = swiper.activeIndex;

    slides.forEach((slide, index) => {
      const content = slide.querySelector<HTMLElement>('.ek-review-slide-content');
      if (!content) return;

      if (index === activeIndex) {
        slide.classList.add('swiper-slide-active');
        content.classList.remove('md:scale-[0.8]', 'md:opacity-70');
        content.classList.add('md:scale-100', 'md:opacity-100');
      } else {
        slide.classList.remove('swiper-slide-active');
        content.classList.remove('md:scale-100', 'md:opacity-100');
        content.classList.add('md:scale-[0.8]', 'md:opacity-70');
      }
    });
  };

  sliders.forEach((slider) => {
    if (slider.dataset.init === 'true') return;
    slider.dataset.init = 'true';

    const isDesktop = window.innerWidth >= 768;
    const initialSlide = isDesktop ? 1 : 0;
    const sliderSection = slider.closest<HTMLElement>('[id^="ek-review-slides-"]');

    const swiperInstance = new window.Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      initialSlide: initialSlide,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: slider.querySelector('.ek-review-slides-button-next'),
        prevEl: slider.querySelector('.ek-review-slides-button-prev'),
      },
      pagination: {
        el: sliderSection?.querySelector('.ek-review-slides-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
          initialSlide: 1,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
          initialSlide: 1,
        },
      },
      on: {
        init: function (swiper: any) {
          updateSlideSizes(swiper, slider);
        },
        slideChange: function (swiper: any) {
          updateSlideSizes(swiper, slider);
        },
        resize: function (swiper: any) {
          updateSlideSizes(swiper, slider);
        },
      },
    });
  });
}

